import {FaBars} from 'react-icons/fa'
import { useState } from 'react';
import EditModal from "./EditModal";    //  @thehamzajunaid's stuff

// imported in Homepage.jsx
// function EntryItem({entry}) {
function EntryItem({entry, user}) {   // is this the correct way of passing args? Yes. 

  //  @thehamzajunaid' stuff
  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <div className="entry">
      <div>
        {/* show the date entry was created. Forgot where 'createdAt' is from */}
        {new Date(entry.createdAt).toLocaleString('en-US')}   
        {/* HAHAHA ITS "LOCALE" NOT "LOCAL" HAHAHA. Got an error from typo */}
      </div>

      <table>
        <tbody>
          <tr>
            <th scope="col">name</th>
            <td>{entry.name}</td>
          </tr>
          <tr>
            <th scope="row">alias</th>
            <td>{entry.alias}</td>
          </tr>
          <tr>
            <th scope="row">rfa</th>
            <td>{entry.medicalCond}</td>
          </tr>
          <tr>
            <th scope="row">notes</th>
            <td>{entry.rfa}</td>
          </tr>
        </tbody>
      </table>

      {/* TODO: SHOW OPTIONS BUTTON ONLY IF ENTRY BELONGS TO USER. ALSO SEE COMMENTED OUT CODE IN HOMEPAGE.JSX...DONE*/}
      {/* "user" in user._id is not defined (CORRECT) */}

      {/* Vicente: 6347119a0ab27ce6660cbd62. Quanique id: 6347149b0ab27ce6660cbd67. 
          Quanique user: 6347119a0ab27ce6660cbd62. 
          I NEED TO USE ENTRY'S USER (NOT _ID) PROPERTY AND USER'S _ID PROPERTY */}
      <div>
        {entry.user === user._id ? (  // 
          <button className="options" onClick={openModal}><FaBars /></button>
          // css for this?  .entry .options 
        ) : ''}
      </div>
      
      <div>
        {/* adding "ariaHideApp={false}" takes away error. */}
        <EditModal ariaHideApp={false} entry={entry} closeModal={closeModal} modalIsOpen={modalIsOpen}/>
      </div>
    </div>
  )
}

export default EntryItem  // imported in Homepage.jsx